import { cn } from '@/lib/utils';
import { useSessionStore, type SessionPhase } from '@/stores/session-store';

const STATES: Record<
  SessionPhase,
  { label: string; className: string; dot: string }
> = {
  idle: {
    label: 'No active room',
    className: 'border-border/70 bg-muted/40 text-muted-foreground',
    dot: 'bg-muted-foreground/50',
  },
  creating: {
    label: 'Creating room',
    className: 'border-brand-2/25 bg-brand-2/10 text-brand-2',
    dot: 'bg-brand-2',
  },
  joining: {
    label: 'Joining room',
    className: 'border-brand-2/25 bg-brand-2/10 text-brand-2',
    dot: 'bg-brand-2',
  },
  connected: {
    label: 'Direct link active',
    className: 'border-primary/25 bg-primary/10 text-primary',
    dot: 'bg-primary',
  },
  reconnecting: {
    label: 'Reconnecting',
    className: 'border-warning/25 bg-warning/10 text-warning',
    dot: 'bg-warning',
  },
  ended: {
    label: 'Room ended',
    className: 'border-border/70 bg-muted/40 text-muted-foreground',
    dot: 'bg-muted-foreground/60',
  },
  error: {
    label: 'Connection problem',
    className: 'border-destructive/25 bg-destructive/10 text-destructive',
    dot: 'bg-destructive',
  },
};

export function ConnectionBadge({ className }: { className?: string }) {
  const phase = useSessionStore((state) => state.phase);
  const peers = useSessionStore((state) => state.peers);
  const state = STATES[phase];
  const peerCount = Object.keys(peers).length;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-[11px] font-medium',
        state.className,
        className,
      )}
      title={phase === 'connected' ? `${peerCount} device${peerCount === 1 ? '' : 's'} connected` : state.label}
    >
      <span className={cn('status-dot', state.dot)} />
      {state.label}
    </span>
  );
}
